<template>
  <img ref="image" :src="blobUrl" @load="loaded"/>
</template>

<script>
  import axios from "axios"
  /**
   * Load an image url as a blob
   */
  async function load(src) {
    const config = { url: src, method: "get", responseType: "blob" }
    const response = await this.$http.request(config)
    return response.data // the blob
  }
  
  export default {
    data() {
      return {
        blobUrl: null,
      }
    },
    props: {
      src: {
        type: String,
      },
    },
    methods: {
      loaded() {
        if (this.blobUrl) URL.revokeObjectURL(this.blobUrl)
      },
    },
    watch: {
      src: {
        immediate: true,
        handler(src) {
          if (!src) return
          load(src).then(blob => {
            this.blobUrl = URL.createObjectURL(blob)
          })
        },
      },
    },
  }
</script>

<style scoped>
</style>